import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFacebookSolid = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2.889 3.667c0-.92.746-1.667 1.667-1.667h16.666c.92 0 1.667.746 1.667 1.667v16.666c0 .92-.746 1.667-1.667 1.667H4.556c-.92 0-1.667-.746-1.667-1.667z"
      />
      <path
        fill="#fff"
        d="M17.889 12c0-2.75-2.25-5-5-5s-5 2.25-5 5c0 2.5 1.812 4.563 4.187 4.938v-3.5h-1.25V12h1.25v-1.125c0-1.25.75-1.937 1.875-1.937.563 0 1.125.124 1.125.124v1.25h-.625c-.625 0-.812.376-.812.75V12h1.375l-.25 1.438h-1.188V17a5.044 5.044 0 0 0 4.313-5"
      />
    </svg>
  );
};
export default SvgFacebookSolid;
